import { forwardRef } from 'react'

import { TextContainer } from 'components/container'
import { Details } from 'components/details'
import DetailsPoster from './assets/Constitution 2.webp'
import { Title } from './styled'

export const Constitution = forwardRef<HTMLDivElement>((_, ref) => (
  <section ref={ref}>
    <TextContainer>
      <Title data-menu-title="Конституция">
        Как менялась Конституция Татарстана
      </Title>
      <p>
        С началом перестройки и гласности в республиках СССР начали активно
        обсуждаться идеи суверенитета. Уже в августе 1990-го во время своей
        поездки по Татарстану тогдашний президент РСФСР Борис Ельцин{' '}
        <a
          href="https://yeltsin.ru/news/boris-elcin-berite-stolko-suverineteta-skolko-smozhete-proglotit/"
          target="_blank"
          rel="noreferrer"
        >
          произнес
        </a>{' '}
        историческую фразу: "Берите столько суверенитета, сколько сможете
        проглотить". Эту фразу он повторял неоднократно и в других регионах.
      </p>
      <p>
        Татарстан стал первым регионом внутри России после развала Советского
        Союза, который объявил о суверенитете и утвердил свою Конституцию,
        опередив на два года принятие российской. Но впоследствии федеральный
        центр постепенно эту независимость у Татарстана отбирал.
      </p>
    </TextContainer>

    <Details posterImage={DetailsPoster}>
      <TextContainer>
        <p>
          В марте 1992 года власти Татарстана провели всенародный референдум в
          соответствии с предложенным текстом будущей Конституции. Жителям
          республики предложили проголосовать за или против того, что
          "Республика Татарстан – суверенное государство, субъект международного
          права, строящее свои отношения с Российской Федерацией и другими
          республиками, государствами на основе равноправных договоров". Более
          61% избирателей поддержали эту формулировку.
        </p>
        <p>
          Самый сложный вопрос, возникший в ходе обсуждения текста будущей
          Конституции, – взаимоотношения с Россией. Глава республики Минтимер
          Шаймиев предложил записать, что Татарстан – "ассоциированное
          государство". Этот вариант вошел в окончательную редакцию Конституции,
          которую утвердил Верховный совет Республики 6 ноября 1992 года и
          подписал уже президент Минтимер Шаймиев. Уже 30 ноября 1992 года
          Конституция вступила в силу.
        </p>
        <p>
          В Конституции также провозглашалось, что Татарстан – это "суверенное
          демократическое государство, выражающее волю и интересы всего
          многонационального народа республики", "неотъемлемое качественное
          состояние Республики Татарстан" – государственный суверенитет. Два
          языка – русский и татарский – считались равноправными государственными
          языками. Общенародным достоянием стали земля и ее недра.
        </p>
        <p>
          За время существования Конституцию Татарстана меняли несколько раз. С
          каждым разом вводились новые ограничения – прав и свобод становилось
          все меньше. Существенную часть полномочий Татарстан потерял после
          прихода к власти Владимира Путина и на фоне войн в Чечне. Руководство
          республики оказывало сопротивление – депутаты Татарстана в своих
          выступлениях и во время переговоров старались отстоять основной текст
          Конституции, но это им не удалось. В апреле 2002 года Конституционный
          суд России обязал в течение шести месяцев "привести главный документ
          Республики в соответствие с Конституцией России".
        </p>
        <p>
          Так в новой редакции Конституции Татарстан стал частью Российской
          Федерации и больше не являлся субъектом международного права.
          Объявлялось еще одно новшество – теперь без референдума можно было
          изменять первую статью Конституции о суверенитете и Договоре с
          Россией. Последующие изменения в отношениях с Москвой уже
          регулировались отдельными договорами, которые подписывали президенты
          Татарстана и России.
        </p>
        <p>
          Но один из главных символов автономности – сам пост президента – был
          упразднен 1 января 2023 года. Взамен в Конституцию вписали новую
          формулировку – "глава Республики Татарстан". Депутаты Татарстана
          заявляли, что это было сделано под давлением федеральной прокуратуры.
          Также из Конституции исключили статью о том, что республика "отвергает
          войну" и запрещает ее пропагандировать, из статьи также исключили
          понятия суверенитета и гражданства Татарстана.
        </p>
      </TextContainer>
    </Details>
  </section>
))
